import React from 'react';
import Group from '@spa/shared/components/Filters/Group';
import CheckboxFilter from '@spa/shared/components/Filters/Checkbox';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { BedroomsIcon, BathroomsIcon } from '@spa/shared';
import FilterCounter from '@spa/shared/components/Filters/FilterCounter';

const getMaxCount = typology => {
  if (!typology) {
    return 0;
  }

  const valueArray = `${typology}`.split(',');

  return Number(valueArray.length === 1 ? typology : Math.max(...valueArray));
};

const Typology = ({ fields, onChangeEventHandler, onChangeHandlerForceArray }) => {
  const { t } = useTranslation('translations');
  const { ensuite, bedrooms, bathrooms } = fields;

  return (
    <Group title={t('filters.sections.typology')}>
      <FilterCounter
        icon={<BedroomsIcon />}
        name="bedrooms"
        min={0}
        max={4}
        value={getMaxCount(bedrooms)}
        onChange={onChangeHandlerForceArray}
        labelTranslation={t('filters.labels.bedroom_general')}
      />
      <FilterCounter
        icon={<BathroomsIcon />}
        name="bathrooms"
        min={0}
        max={4}
        value={getMaxCount(bathrooms)}
        onChange={onChangeHandlerForceArray}
        labelTranslation={t('filters.labels.bathrooms_general')}
      />
      <CheckboxFilter
        name="ensuite"
        value={true}
        onChange={onChangeEventHandler}
        selected={ensuite && ensuite === 'true'}
        label={t('filters.labels.private_bathroom')}
      />
    </Group>
  );
};

Typology.propTypes = {
  fields: PropTypes.object.isRequired,
  onChangeEventHandler: PropTypes.func.isRequired,
  onChangeHandlerForceArray: PropTypes.func.isRequired
};

export default Typology;
